import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Stack,
  useTheme,
} from '@mui/material';
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  Call as CallIcon,
} from '@mui/icons-material';
import { useAppConfig } from '../../contexts/AppConfigContext';

const ContactUs = ({ onBack }) => {
  const theme = useTheme();
  const { schoolName } = useAppConfig();
  
  // Contact information - can be fetched from config or hardcoded
  const contactEmail = 'support@school.com'; // TODO: Get from app config
  const contactPhone = '+1 (555) 123-4567'; // TODO: Get from app config

  const handleCall = () => {
    // Remove any non-digit characters except + for tel: link
    const phoneNumber = contactPhone.replace(/[^\d+]/g, '');
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleEmail = () => {
    window.location.href = `mailto:${contactEmail}`;
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, pt: { xs: 2.5, sm: 3 } }}>
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: 3,
          background: 'linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.95) 100%)',
        }}
      >
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Stack spacing={3}>
            {/* Email Section */}
            <Box
              sx={{
                p: 3,
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'grey.50',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                '&:hover': {
                  bgcolor: 'grey.100',
                  borderColor: theme.palette.primary.main,
                  transform: 'translateY(-2px)',
                  boxShadow: 2,
                },
              }}
            >
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: '50%',
                  bgcolor: 'primary.main',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                  mb: 2,
                  boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
                }}
              >
                <EmailIcon sx={{ fontSize: 32, color: 'white' }} />
              </Box>
              <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}>
                Email
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{
                  mb: 2,
                  fontSize: { xs: '0.95rem', sm: '1rem' },
                  wordBreak: 'break-word',
                }}
              >
                {contactEmail}
              </Typography>
              <Button
                variant="outlined"
                startIcon={<EmailIcon />}
                onClick={handleEmail}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  px: 3,
                }}
              >
                Send Email
              </Button>
            </Box>

            {/* Phone Section */}
            <Box
              sx={{
                p: 3,
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'grey.50',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                '&:hover': {
                  bgcolor: 'grey.100',
                  borderColor: theme.palette.success.main,
                  transform: 'translateY(-2px)',
                  boxShadow: 2,
                },
              }}
            >
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: '50%',
                  bgcolor: 'success.main',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                  mb: 2,
                  boxShadow: `0 4px 12px ${theme.palette.success.main}40`,
                }}
              >
                <PhoneIcon sx={{ fontSize: 32, color: 'white' }} />
              </Box>
              <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}>
                Phone
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{
                  mb: 2,
                  fontSize: { xs: '0.95rem', sm: '1rem' },
                }}
              >
                {contactPhone}
              </Typography>
              <Button
                variant="contained"
                startIcon={<CallIcon />}
                onClick={handleCall}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  px: 3,
                  bgcolor: 'success.main',
                  '&:hover': {
                    bgcolor: 'success.dark',
                  },
                }}
              >
                Call Now
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ContactUs;

